module.exports = __webpack_public_path__ + "static/media/paket2New.74fb2b16.jpg";